import AppHeader from "@/app/components/common/app-header/AppHeader";
import React, {CSSProperties, ReactNode, useState} from "react";
import {SidebarInset, SidebarProvider} from "@/app/components/common/app-sidebar/AppSidebar";
import AppAside from "@/app/components/common/app-aside/AppAside";
import {MainCtaBtn} from "@/app/components/common/main-cta-btn/MainCtaBtn";
import {BadgeQuestionMark} from "lucide-react";
import {useTranslations} from "next-intl";
import {CtaBtn} from "@/app/components/common/cta-btn/CtaBtn";
import ScrollToTopSvg from "@/app/components/icons/ScrollToTopSvg";
import {cn} from "@/lib/utils";
import {usePathname} from "@/i18n/navigation";
import {useZendeskWidget} from "@/hooks/useZendeskWidget";
import {SCROLL_TO_TOP_THRESHOLD, useScrollPastThreshold} from "@/hooks/useScrollPastThreshold";


interface IProps {
    children: ReactNode;
}

export default function DesktopVersion({children}: IProps) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const t = useTranslations();
    const isVisible = useScrollPastThreshold(SCROLL_TO_TOP_THRESHOLD);
    const pathname = usePathname();
    const {onOpenWidget} = useZendeskWidget();

    const onScrollTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    return (
        <>
            <SidebarProvider open={isSidebarOpen} onOpenChange={setIsSidebarOpen} style={{
                "--sidebar-width": "264px",
            } as CSSProperties}>

                <AppAside open={isSidebarOpen}/>
                <SidebarInset className={'contain-inline-size'}>
                    <AppHeader className={'sticky top-0 z-3'}/>
                    <div className="flex-1 flex flex-col w-full">
                        {children}
                    </div>
                </SidebarInset>
            </SidebarProvider>
            <CtaBtn
                onClick={onScrollTop}
                className={cn(
                    'w-[172px] h-[51px] md:text-[16px] text-noble-black-300 fixed bottom-[20px] left-1/2 transition-opacity duration-300',
                    isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
                )}
            >
                <div className={'flex items-center justify-center'}>
                    <ScrollToTopSvg/>
                    {t('AppFooter.scrollToTop')}
                </div>
            </CtaBtn>
            {
                !pathname.includes("games") ? (
                    <MainCtaBtn onClick={onOpenWidget} className={'fixed bottom-[16px] right-[16px] z-20'}>
                        <BadgeQuestionMark/>
                    </MainCtaBtn>
                ) : null
            }
        </>
    )
}
